// These styles are merged with styles from er2_ui to properly display
// the subheader for the select station map step of the application.
import * as colors from '../styles/colors'

export const styles = {
    breadcrumbHeader: {
        width: '100%',
    },
    breadcrumbs: {
        gridColumnEnd: 'breadcrumbOverflow',
        pointerEvents: 'none',
    },
    headerTextContent: {
        flexGrow: '1',
        fontFamily: 'Roboto Condensed',
        fontWeight: 400,
    },
}

export const stylesNoHeader = {
    breadcrumbs: {
        gridRowStart: 'top',
    },
}

export const contextBarStyles = {
    contextBar: {
        backgroundColor: colors.gray,
        color: colors.textColor,
        display: 'flex',
        flexDirection: 'column',
        gridColumnStart: 'left',
        gridColumnEnd: 'controlBar',
        gridRowStart: 'subHeader',
        gridRowEnd: 'end',
    },
    contextBarBottom: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
    },
    contextBarTop: {
        flexGrow: '1',
    },
    iconCtr: {
        padding: '10px',
        textAlign: 'center',
        fontSize: '20px',
    },
    spacer: {
        backgroundColor: colors.secondaryOne,
        height: '44px',
    },
}

export const contextBarStylesNoHeader = {
    contextBar: {
        gridRowStart: 'top',
    },
}

export default styles
